import React, { useCallback, useEffect, useState } from 'react'
import {Alert} from '@material-ui/lab';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import FolderIcon from '@material-ui/icons/Folder';
import DeleteIcon from '@material-ui/icons/Delete';

import DescriptionIcon from '@material-ui/icons/Description';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import InfoIcon from '@material-ui/icons/Info';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ShareIcon from '@material-ui/icons/Share';
import GetAppIcon from '@material-ui/icons/GetApp';
import ControlCameraIcon from '@material-ui/icons/ControlCamera';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';

import {useDropzone} from 'react-dropzone'
import { useLocation, useParams, useHistory } from "react-router-dom";
import { CardActions } from '@material-ui/core';

const prettyBytes = require('pretty-bytes');

const axios = require('axios');

const publicUrl = process.env.REACT_APP_GOZ_PUBLIC_URL || '';
const backend = process.env.REACT_APP_GOZ_BACKEND_URL || publicUrl

const useStyles = makeStyles({
    table: {
      minWidth: 650,
    },
    editor: {
        minHeight: 800,
    },
    form: {
        margin: '10px'
    },
    dropzone: {
        backgroundColor: 'lightGrey',
    },
  });


export const Context = React.createContext();


const FileShareDialog = (props) => {
    const classes = useStyles();
    const { onClose, open } = props;
  
    const handleClose = () => {
      onClose();
    };

    const [errMsg, setErrMsg] = useState('')
    const [msg, setMsg] = useState('')
    const [link, setLink] = useState('')
    const [name, setName] = useState('')
    const [access, setAccess] = useState('ro')
    const [duration, setDuration] = useState(30)

    const copyLink = () => {
        navigator.clipboard.writeText(link);
        setMsg('Link copied to clipboard');
    }

    const getlink = () => {
        let f = props.file;
        let token = props.token;
        axios.get(`${backend}/api/shares${f}`, {
            params: {
                name: name,
                access: access,
                duration: parseInt(duration) * 24 * 3600,
            },
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(resp => {
            // console.log('link', resp.data)
            let host = window.location.protocol + "//" + window.location.host;
            setLink(`${host}?token=${resp.data.token}`)
            setErrMsg('')
        }).catch(err => {
            setErrMsg(err.message)
        })
    }
      return (<React.Fragment>
         {props.file &&
          <Dialog onClose={handleClose} aria-labelledby="file information dialog" open={open} maxWidth="lg" fullWidth={true}>
            <DialogTitle id="file-information-title">{props.file}</DialogTitle>
                {errMsg && <Alert severity="error">{errMsg}</Alert>}

                <FormControl className={classes.form}>
                <InputLabel  htmlFor="my-name">Share link label</InputLabel>
                <Input id="my-name" onChange={(e) => setName(e.target.value)} value={name}/>
                </FormControl>

                <FormControl className={classes.form}>
                <InputLabel htmlFor="my-mode">Access</InputLabel>
                <Select id="my-mode" onChange={(e) => setAccess(e.target.value)} value={access}>
                    <option value="ro">ro</option>
                    <option value="rw">rw</option>
                    </Select>
                </FormControl>

                <FormControl className={classes.form}>
                <InputLabel  htmlFor="my-duration">Duration (days)</InputLabel>
                <Input id="my-duration" onChange={(e) => setDuration(e.target.value)} value={duration}/>
                </FormControl>
                <Grid container>
                    <Grid item xs={8}>
                        <Button className={classes.form} variant="contained" color="primary" onClick={() => getlink()}>Get link</Button>
                    </Grid>
                    {link && 
                    <Grid item xs={4}>
                        <Button className={classes.form} variant="contained" color="secondary" onClick={() => copyLink()}>Copy link</Button>
                    </Grid>}
                </Grid>
                {link && 
                <Grid container>
                    <Grid item xs={12}>
                    <TextField className={classes.form} fullWidth="true" multiline="true" disabled value={link} id="outlined-basic" label="Share link" variant="outlined"/>
                    </Grid>
                </Grid>
                }
                {msg && 
                <div>
                    <div><span class="label label-success">{msg}</span></div>
                </div>
                }
          </Dialog>
        }
        </React.Fragment>)
}

// Dialog to create a directory
const NewDirDialog = (props) => {
    const classes = useStyles();
    const { onCancel, onCreate, open } = props;
    const [dir, setDir] = useState("")
  
    const handleCancel = () => {
      onCancel();
    };
    const handleCreate = () => {
        if (dir === "") {
            onCancel();
            return;
        }
        onCreate(dir);
      };

    return (
        <React.Fragment>
        <Dialog onClose={handleCancel} aria-labelledby="create directory dialog" open={open}>
        <DialogTitle id="file-information-title">Create directory</DialogTitle>
        <Card className={classes.form}>
        <CardContent>
            <FormControl>
            <InputLabel htmlFor="my-dir">Directory</InputLabel>
            <Input id="my-dir" onChange={(e) => setDir(e.target.value)} value={dir}/>
            </FormControl>
        </CardContent>
        <CardActions>
            <Button variant="contained" color="primary" onClick={() => handleCreate()}>Create</Button>
            <Button variant="contained" color="primary" onClick={() => handleCancel()}>Cancel</Button>
        </CardActions>
        </Card>
        </Dialog>
        </React.Fragment>
    )
}

const FileDeleteDialog = (props) => {
    const classes = useStyles();
    const [errMsg, setErrMsg] = useState('')
    const [infoMsg, setInfoMsg] = useState('')
    const [counter, setCounter] = useState(0);


        const { onClose, file, open, dir, token } = props;
      
        const handleClose = () => {
          onClose();
        };

        useEffect(() => {
            if(!dir || !file) {
                return
            }
            setInfoMsg("Scanning...")
            recursiveDeletion(dir, file, true, token).then((nbfiles) => {
                setCounter(nbfiles)
                setInfoMsg("Will delete")
            }).catch(err => setErrMsg(err.message))
        }, [dir, file, token])

        const deleteFile = async (path, fake, auth_token) => {
            if(fake) {
                // console.debug('should delete', path)
                return
            }
            await axios.delete(`${backend}/api/files${path}`, {
                headers: {
                    'Authorization': 'Bearer ' + auth_token
                },
            });   
        }
    
        const getFiles = async (path, auth_token) => {
            let resp = await axios.get(`${backend}/api/files${path}`, {
                headers: {
                    'Authorization': 'Bearer ' + auth_token
                }
            })
            // console.log('files=', path, resp.data)
            return resp.data.Content
        }

        const recursiveDeletion = async (path, fileToDelete, fake, auth_token) => {
            let nbFilesToDelete = 0
            if (fileToDelete.Dir) {
                let files = await getFiles(`${path}/${fileToDelete.Name}`, auth_token)
                if(files.length > 0) {
                    for(let i=0;i<files.length;i++) {
                        try {
                        nbFilesToDelete += await recursiveDeletion(`${path}/${fileToDelete.Name}`, files[i], fake, auth_token)
                        } catch (err) {
                            console.debug('cannot delete', path, err)
                        }
                    }
                }
                try {
                    await deleteFile(`${path}/${fileToDelete.Name}`, fake, auth_token)
                } catch (err) {
                    console.debug('cannot delete', path, err)
                }
            } else {
                try {
                    await deleteFile(`${path}/${fileToDelete.Name}`, fake, auth_token)
                    nbFilesToDelete++
                } catch (err) {
                    console.debug('cannot delete', path, err)

                }
            }
            return nbFilesToDelete
        }

        const deleteConfirm = () => {
            //toDelete = 0
            setCounter(0)
            setInfoMsg("Deleting...")
            recursiveDeletion(dir, file, false, token).then(() => {
                handleClose()
            }).catch(err => {
                setErrMsg(err.message)
            })
        }

        return (
            <React.Fragment>
            {errMsg && <Alert severity="error">{errMsg}</Alert>}
            {file && 
            <Dialog onClose={handleClose} aria-labelledby="file information dialog" open={open}>
            <DialogTitle id="file-information-title">{file.Name}</DialogTitle>
            <Card className={classes.form}>
                <CardContent>
                    {file.Dir && <div>{file.Name} is a directory, delete all content?</div>}
                    {infoMsg && <Alert severity="info">{infoMsg} {counter} files</Alert>}
                </CardContent>
                <CardActions>
                    <Button variant="contained" color="primary" onClick={() => deleteConfirm()}>Confirm deletion</Button>
                    <Button variant="contained" color="primary" onClick={() => handleClose()}>Cancel</Button>
                </CardActions>
            </Card>

            </Dialog>
            }



            </React.Fragment>
        )
}

const FileInfoDialog = (props) => {
        const classes = useStyles();
        const { onClose, fileInfo, open } = props;
      
        const handleClose = () => {
          onClose();
        };
      
        return (
        <React.Fragment>
         {fileInfo &&
          <Dialog onClose={handleClose} aria-labelledby="file information dialog" open={open}>
            <DialogTitle id="file-information-title">{fileInfo.Name}</DialogTitle>
                <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="files">
                <TableHead>
                <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Size</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Permissions</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                    <TableCell>{fileInfo.Name}</TableCell>
                    <TableCell>{prettyBytes(fileInfo.Size)}</TableCell>
                    <TableCell>{fileInfo.Date}</TableCell>
                    <TableCell>{fileInfo.Perm}</TableCell>
                    </TableRow>
                </TableBody>
                </Table>
                </TableContainer>
          </Dialog>}
        </React.Fragment>
        );
      


}

const OooEditor = (props) => {
    const [fileInfo, setFileInfo] = useState(null)
    const oooEnabled = process.env.REACT_APP_GOZ_OOO || false
    const codimdEnabled = process.env.REACT_APP_GOZ_CODIMD || false

    const ooEdit = (filename, oooEnabled, codimdEnabled) => {
        let ooext = []
        if (oooEnabled) {
            ooext = ['doc', 'docx', 'dotx', 'odt', 'rtf', 'txt', 'pdf', 'html', 'epub', 'xps', 'xml', 'docxf', 'xls', 'xlsx', 'xltx', 'ods', 'ots', 'csv', 'ppt', 'pptx', 'potx', 'odp', 'otp'];
        }
        if (codimdEnabled) {
            ooext.push('md')
        }
        if(!oooEnabled && !codimdEnabled) {
            return false
        }
        for(let i=0;i<ooext.length;i++) {
            if (filename.endsWith('.'+ooext[i])){
                return true;
            }
        }
        return false;
    }


    useEffect(() => {
        if(!oooEnabled && !codimdEnabled) {
            // preview only
            setFileInfo({dest: `/api/download${props.dir}/${props.file.Name}?token=${props.token}&preview=1`, edit: false})
            // console.debug('ooo not enabled')
            return
        }
        if(props.file) {
            let fileIsEditable = false
            let dest  = `/api/download${props.dir}/${props.file.Name}?token=${props.token}&preview=1`
            if (ooEdit(props.file.Name, oooEnabled, codimdEnabled)) {
                fileIsEditable = true
                let tool = 'ooo'
                if (props.file.Name.endsWith('.md')) {
                    tool = 'codimd'
                }
                let path = props.file.Name
                dest = `/${tool}${path}?token=${props.token}`
                if (path[0] !== "/") {
                    dest = `/${tool}${props.dir}/${path}?token=${props.token}`
                }
            }
            setFileInfo({dest: dest, edit: fileIsEditable})
        }
    }, [props, oooEnabled, codimdEnabled])

    return (<React.Fragment>
        { fileInfo && fileInfo.edit && <a href={fileInfo.dest} rel="noreferrer" target="_blank"><Tooltip  title="edit"><EditIcon/></Tooltip></a>}
        { fileInfo && !fileInfo.edit && <a href={fileInfo.dest} rel="noreferrer" target="_blank"><Tooltip  title="preview"><VisibilityIcon/></Tooltip></a>}
    </React.Fragment>)
}

const FileBrowser = (props) => {
    const [files, setFiles] = useState([])
    const [dir, setDir] = useState('/')
    const [readOnly, setReadOnly] = useState(false);
    const [errMsg, setErrMsg] = useState('')
    const [fileInfo, setFileInfo] = useState(null)
    const [fileDelete, setFileDelete] = useState(null)
    const [fileShare, setFileShare] = useState(null)
    const [loading, setLoading] = useState(false)
    const [search, setSearch] = useState('');
    // should get user shares
    const [token, setToken] = useState(null)
    const [user, setUser] = useState({
      user: "",
      password: "",
    })
    const [createDir, setCreateDir] = useState(false)

    const [fileToMove, setFileToMove] = useState(null)

    const history = useHistory();



    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }
    let query = useQuery();

    let { gotoroute } = useParams();

    useEffect(() => {
        if(!gotoroute && dir !== '/') {
            setDir('/')
            return
        }
        if(!gotoroute) {
            return
        }
        let goto_path = `/${gotoroute}`
        if (goto_path && goto_path !== dir) {
            console.log('gotoroute', gotoroute, dir)
            setDir(goto_path)
        }
    }, [gotoroute, dir])

    useEffect(() => {
        let t = localStorage.getItem("goz-token");
        let qt = query.get('token');
        if (qt) {
            t = qt;
        }
        if(t && t !== token) {
            setToken(t)
            props.onLogin(t)
        }
    }, [query, token, props])

    const logout = (onLogout) => {
        setToken(null);
        localStorage.removeItem("goz-token")
        if(onLogout) {
            onLogout()
        }
        window.location.replace('/')
    }
    const log2 = () => {
        axios.post(`${backend}/api/auth`, user).then((response) => {
            setToken(response.data.Token)
            props.onLogin(response.data.Token)
            localStorage.setItem("goz-token", response.data.Token)
            setUser({...user, password: ''})
        }).catch(err  => {
            setErrMsg(err.response.data ? err.response.data : err.message)
        });
    
    }

    const isSearch = (name) => {
        return (search.length===0 || (search.length>=3 && name.indexOf(search)>=0))
    }

    const rename = (f) => {
        let path = f.Name;
        let dest = `${path}`
        if (path[0] !== "/") {
            dest = `${dir}/${path}`
        }
        setLoading(true)
        axios.patch(`${backend}/api/files${f.moveFrom}`, null, {
            headers: {
                'Authorization': 'Bearer ' + token
            },
            params: {
                name: dest,
            }
            
        }).then(() => {
            setFileToMove(null);
            return getFiles(dir, token);
        })
        .then((resp) => {
            resp.data.Content.sort(fileSort)
            setFiles(resp.data.Content)
            setLoading(false)
            setErrMsg('')
        })
        .catch((err) => {
            setFileToMove(null)
            setErrMsg("Failed to move file: " + err.message)
        })
    }

    const getFiles = (path, auth_token) => {
        if(!auth_token) {return}
        return axios.get(`${backend}/api/files${path}`, {
            headers: {
                'Authorization': 'Bearer ' + auth_token
            }
        })
    }

    const handleCreateDirectory = (value) => {
        setCreateDir(false)
        setLoading(true)
        setSearch('')
        axios.post(`${backend}/api/upload${dir}/${value}`, null, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        })
        .then(() => {
            return getFiles(dir, token);
        })
        .then((resp) => {
            resp.data.Content.sort(fileSort)
            setFiles(resp.data.Content)
            setLoading(false)
            setErrMsg('')
        })
        .catch(err => {
            console.error(err.message)
            setErrMsg(err.message)
        })
    }
    const handleCancelCreateDirectory = () => {
        setCreateDir(false)
    }

    const handleFileInfoClose = () => {
        setFileInfo(null)
    };

    const handleFileDeleteClose = () => {
        setFileDelete(null)
        setLoading(true)
        getFiles(dir, token).then((resp) => {
            resp.data.Content.sort(fileSort)
            setFiles(resp.data.Content)
            setLoading(false)
            setErrMsg('')
         })
    }

    const handleFileShareClose = () => {
        setFileShare(null)
    }

    const downloadFileLink = (f, auth_token) => {
        if(!auth_token) {return}
        let path = f.Name;
        let dest = `${path}`
        if (path[0] !== "/") {
            dest = `${dir}/${path}`
        }
        return `${backend}/api/download${dest}?token=${auth_token}`
    }

    const getFileInfo = (f) => {
        if(!token) {return}
        let path = f.Name;

        let dest = `${path}`
        if (path[0] !== "/") {
            dest = `${dir}/${path}`
        }
        // console.debug('getfileinfo', dest)
        axios.get(`${backend}/api/info${dest}`, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(resp => {
            // console.debug(resp.data)
            setFileInfo(resp.data.Content[0])
        }).catch(err => {
                setErrMsg(err.message)
                if(err.response.status === 401) {
                    logout()
                }
        })
    }

    const classes = useStyles();

    const goto = (newdir, fileinfo) => {
        if (fileinfo == null) {
            //setDir(newdir)
            history.push('/file'+newdir)
            return
        }
        let path = fileinfo.Name;
        if (!fileinfo.Dir) {
            return
        }

        let dest = `${path}`
        if (path === '..') {
            let dirs = newdir.split('/')
            // Should check if subdir is a base share, else prevent
            //setDir(dirs.slice(0, dirs.length-1).join('/'))
            history.push('/file'+dirs.slice(0, dirs.length-1).join('/'))
            return
        }
        if (path[0] !== "/") {
            dest = `${newdir}/${path}`
        }
        setErrMsg('')
        //setDir(dest)

        history.push('/file'+dest)
    }


    const fileSort = (a, b) => {
        if(a.Dir && !b.Dir) {
            return -1
        } else if (b.Dir && !a.Dir) {
            return 1
        }
        return a.Name < b.Name ? -1 : 1
    }
    useEffect(() => {
        let dest = dir;
        if (dir === undefined || dir === null|| dir === '') {
            dest = "/";
        }
        if(!token) {return}

        // console.log('fetch', dest)
        setLoading(true)
        setSearch('')
        getFiles(dest, token).then((resp) => {
            if(dest !== '/') {
                resp.data.Content.sort(fileSort)
            }
            // console.debug('files', dest, resp.data.Content)
            setReadOnly(resp.data.ReadOnly ?? false)
            setFiles(resp.data.Content)
            setLoading(false)
            //setErrMsg('')

        }).catch(err => {
            setErrMsg(dir+': '+ err.message)
            // setDir('/')
            history.push('/file/')
            // goto('/', {Name: '/', Dir: true})
            setLoading(false)
            if(err.response.status === 401) {
                logout(props.onLogout)
            }
        })
    }, [dir, token, props.refresh, props.onLogout])


    const fileType = (isDir, name) => {
        if (isDir) {
            return (<FolderIcon/>)
        }
        const ooext = ['doc', 'docx', 'dotx', 'odt', 'rtf', 'txt', 'pdf', 'html', 'epub', 'xps', 'xml', 'docxf', 'xls', 'xlsx', 'xltx', 'ods', 'ots', 'csv', 'ppt', 'pptx', 'potx', 'odp', 'otp'];
        let ext = name.split('.').pop();
        if(ext.endsWith('pdf')) {
            return (<PictureAsPdfIcon color="primary"/>)
        } else if(ooext.indexOf(ext) > 0) {
            return (<DescriptionIcon color="primary"/>)
        }
        return (<DescriptionIcon/>)
    }

    const onDrop = useCallback((acceptedFiles) => {
        if(!props.upload) {
            return;
        }
        let files2upload = [];
        acceptedFiles.forEach((file) => {
            // console.log('drop',file)
            files2upload.push(file)
        })
        props.upload(files2upload, dir, token);
        
      }, [dir, props, token])
    const {getRootProps, getInputProps} = useDropzone({onDrop})

    const shareAccess = (f) => {
        let dest = `${f.Name}`
        if (f.Name[0] !== "/") {
            dest = `${dir}/${f.Name}`
        }
        setFileShare(dest)
    }

    const deleteFile = (f) => {
        setFileDelete(f);

    }

    const moveFile = (f) => {
        f.moveFrom = `${dir}/${f.Name}` ;
        setFileToMove(f)
    }

    const moveFileTo = () => {
        rename(fileToMove)
    }

    return (
        <React.Fragment>
        {token === null && <Box className="left-action">
        <Grid>
        <Grid item xs={12}>
            {errMsg && <Alert severity="error">{errMsg}</Alert>}
        </Grid>
        <Grid item xs={12}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormControl>
                    <InputLabel htmlFor="my-user">User id</InputLabel>
                    <Input autoComplete="username" id="my-user" onChange={(e) => setUser({...user, user: e.target.value})} value={user.user}/>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl>
                    <InputLabel htmlFor="my-password">Password</InputLabel>
                    <Input autoComplete="current-password" type="password" id="my-password" onChange={(e) => setUser({...user, password: e.target.value})} value={user.password}/>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl>
                    <Button variant="contained" color="primary" onClick={()=>log2()}>Log in</Button>
                    </FormControl>
                </Grid>
            </Grid>
        </Grid>
        </Grid>
        </Box>
        }
        {token !== null &&
        <Grid>
            {dir !== '/' && <Grid item xs={12}>
            <Card className={classes.form}><CardContent>
            <div {...getRootProps()}>
                <input {...getInputProps()} />
                <p>Drag 'n' drop some files here, or click to select files</p>
            </div>
            </CardContent></Card>
            </Grid> }

            <Grid item xs={12}>
                {errMsg && <Alert severity="error">{errMsg}</Alert>}
                {loading && <Alert severity="info">Loading...</Alert>}
            </Grid>
            <Grid item xs={12}>
                <Grid container>
                    <Grid item xs={8}>
                        <Alert severity="info">{gotoroute} {readOnly ? "* Read only mode *" : ""}</Alert>
                    </Grid>
                    <Grid item xs={4}><Button size="small" variant="contained" color="primary" onClick={()=> logout()}>Logout</Button></Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12}><Input id="search" placeholder="search" onChange={(e) => setSearch(e.target.value)} value={search}/></Grid>
                </Grid>
                {!loading && <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="files">
                <TableHead>
                <TableRow>
                    <TableCell size="small">Type</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Size</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>
                        {dir !== "/" && <Button size="small" variant="contained" color="primary" onClick={() => setCreateDir(true)}>Create dir</Button>}
                    </TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {fileToMove && <TableRow>
                    <TableCell size="small">Moving...</TableCell>
                    <TableCell>{dir}/<Input id="moveto" onChange={(e) => setFileToMove({...fileToMove, Name: e.target.value})} value={fileToMove.Name}/>
</TableCell>
                    <TableCell></TableCell>
                    <TableCell>From {fileToMove.moveFrom}</TableCell>
                    <TableCell>
                        <Button variant="contained" color="primary" onClick={() => moveFileTo()}>Move</Button>
                        <Button variant="contained" color="primary" onClick={() => setFileToMove(null)}>Cancel</Button>
                    </TableCell>
                </TableRow>}
                {dir !== "/" && <TableRow>
                    <TableCell size="small" onClick={() => goto(dir, {Name: '..', Dir: true})}>
                    {fileType(true)}
                    </TableCell>
                    <TableCell>..</TableCell>
                    <TableCell>0</TableCell>
                    <TableCell></TableCell>
                    <TableCell><Button size="small" variant="contained" color="primary" onClick={() => goto('/', null)}>Back to root</Button></TableCell>
                    </TableRow>
                }
                {files.map((f) => isSearch(f.Name) && (
                    <TableRow key={f.Name}>
                    <TableCell size="small" onClick={() => goto(dir, f)}>
                    {fileType(f.Dir, f.Name)}
                    </TableCell>
                    <TableCell>{f.Name} {f.Sharing && <span>[{f.Sharing}]</span>}</TableCell>
                    <TableCell>{prettyBytes(f.Size)}</TableCell>
                    <TableCell>{f.Date}</TableCell>
                    <TableCell>
                        <Tooltip  title="info"><InfoIcon onClick={() => getFileInfo(f)}/></Tooltip>
                        {!f.Dir && <a target="_blank" rel="noreferrer noopener" href={downloadFileLink(f, token)}><Tooltip  title="download"><GetAppIcon/></Tooltip></a>}
                        {dir !== "/" && <Tooltip  title="share"><ShareIcon onClick={() => shareAccess(f)}/></Tooltip>}
                        {!f.Dir && <OooEditor dir={dir} file={f} token={token}/>}
                        {!f.Dir && <Tooltip  title="move"><ControlCameraIcon onClick={() => moveFile(f)}/></Tooltip>}
                        {dir !== "/" && <Tooltip title="delete"><DeleteIcon onClick={() => deleteFile(f)}/></Tooltip>}
                    </TableCell>
                    </TableRow>
                ))}
                </TableBody>
                </Table>
                </TableContainer>}
            </Grid>
        </Grid>
        }
        <FileDeleteDialog file={fileDelete} token={token} dir={dir} open={fileDelete!==null} onClose={handleFileDeleteClose} />
        <FileInfoDialog fileInfo={fileInfo} open={fileInfo !== null} onClose={handleFileInfoClose} />
        <FileShareDialog file={fileShare} token={token} open={fileShare !== null} onClose={handleFileShareClose} />
        <NewDirDialog open={createDir} onCreate={handleCreateDirectory} onCancel={handleCancelCreateDirectory} />
        </React.Fragment>
    )
}

export default FileBrowser;